import type { ProjectFileResponseDto } from '@inference.engine/workspace-api-client/web';
import type { ProjectFileVersion } from '@/entities/project-file';

/** File with downloadUrl properly typed as string instead of the generated generic object. */
export type AssetFile = Omit<ProjectFileResponseDto, 'downloadUrl'> & {
  downloadUrl: string | null;
};

const unwrapDownloadUrl = (raw: unknown): string | null => (raw as string | undefined) ?? null;

export const toAssetFile = (file: ProjectFileResponseDto): AssetFile => ({
  ...file,
  downloadUrl: unwrapDownloadUrl(file.downloadUrl),
});

export const mergeVersionIntoAssetFile = (
  file: AssetFile,
  version: ProjectFileVersion,
): AssetFile => ({
  ...file,
  downloadUrl: unwrapDownloadUrl(version.downloadUrl),
  fileSize: version.fileSize,
  createdAt: version.createdAt,
});
